import { combineReducers } from "redux";
import userReducer from "./user.reducer";
import usersReducer from "./Users.reducer";
import postReducer from "./post.reducer";
import singlePostReducer from "./singlePost.reducer";
import commentReducer from "./comment.reducer";
import commentTutoReducer from "./commentTuto.reducer";
import likesReducer from "./likes.reducer";
import knowledgeReducer from "./knowledge.reducer";
import knowledgeFav from "./knowledgeFav.reducer";
import notificationReducer from "./notifications.reducer";
import requestKnowledgeReducer from "./requestKnowledge.reducer";
import scheduledPostReducer from "./scheduledPost.reducer";
import outilsExtReducer from "./outilsExt.reducer";
import boiteaoutilReducer from "./boiteaoutil.reducer";
import quicontacterReducer from "./quicontacter.reducer";
import chatbotReducer from "./chatbot.reducer";
import serviceReducer from "./service.reducer";
import formationCategoryReducer from "./formationCategory.reducer";
import formationsReducer from "./formations.reducer";
import formationLearnerReducer from "./formationLearner.reducer";
import prodStatsReducer from "./prodStats.reducer";

export default combineReducers({
  userReducer,
  usersReducer,
  postReducer,
  singlePostReducer,
  commentReducer,
  likesReducer,
  knowledgeReducer,
  notificationReducer,
  knowledgeFav,
  requestKnowledgeReducer,
  scheduledPostReducer,
  outilsExtReducer,
  boiteaoutilReducer,
  commentTutoReducer,
  quicontacterReducer,
  chatbotReducer,
  serviceReducer,
  formationCategoryReducer,
  formationsReducer,
  formationLearnerReducer,
  prodStatsReducer,
});
